module.exports = __webpack_public_path__ + "static/media/FazzNeue-Medium.d46299c6.ttf";